import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import "./styles.scss"

import iconGroup from "./images/icon-group.svg"
import iconHandshake from "./images/icon-handshake.svg"
import iconPersonTick from "./images/icon-person-tick.svg"
import iconTick from "./images/icon-tick.svg"
import iconExclamation from "./images/icon-exclamation.svg"

import {
  fetchNotifications,
  archiveNotification
} from "../../services/notifications"

class Notifications extends React.Component {
  componentDidMount() {
    const {
      onFetchNotifications,
      store: { user }
    } = this.props

    onFetchNotifications(user.token)
  }

  handleArchiveNotification = (e, id) => {
    if (e) e.preventDefault()

    const {
      onArchiveNotification,
      store: { user }
    } = this.props

    onArchiveNotification(user.token, [id])
  }

  render() {
    const { store } = this.props

    const icons = {
      handshake: iconHandshake,
      clock: iconGroup,
      group: iconGroup,
      person_tick: iconPersonTick,
      exclamation: iconExclamation,
      tick: iconTick
    }

    const notificationTypes = {
      I: {
        btnText: "Accept invite",
        btnLink: "/my-participants"
      },
      H: {
        btnText: "See support request",
        btnLink: "/my-participants"
      },
      S: {
        btnText: "See suggestion",
        btnLink: "/my-plan/suggestions"
      },
      U: {
        btnText: "Ok, got it",
        btnAction: id => this.handleArchiveNotification(null, id)
      }
    }

    return (
      <CSSTransition
        in={!!store.notificationCount}
        timeout={500}
        unmountOnExit
        classNames="notifications"
      >
        <div className="notifications">
          <div className="container">
            <div className="row">
              <div className="col-md-11 offset-md-1">
                <ul className="row notifications_list">
                  <TransitionGroup component={null}>
                    {store.notifications
                      .slice(0, 3)
                      .map(({ id, contents, icon_desc, notification_type }) => {
                        const icon = icons[icon_desc]
                        const btnText =
                          notificationTypes[notification_type].btnText
                        const btnLink =
                          notificationTypes[notification_type].btnLink
                        const btnAction =
                          notificationTypes[notification_type].btnAction

                        return (
                          <CSSTransition
                            key={id}
                            timeout={600}
                            classNames="notifications_item"
                          >
                            <li className="col-3 notifications_item">
                              <div className="notifications_item_inner">
                                <div className="notifications_item_icon">
                                  <img src={icon} alt="message icon" />
                                </div>
                                <div className="notifications_item_description">
                                  {contents}
                                </div>

                                {!!btnLink && (
                                  <Link
                                    className="notifications_item_btn"
                                    to={btnLink}
                                  >
                                    {btnText}
                                  </Link>
                                )}

                                {!!btnAction && (
                                  <button
                                    type="button"
                                    className="notifications_item_btn"
                                    onClick={() => {
                                      btnAction(id)
                                    }}
                                  >
                                    {btnText}
                                  </button>
                                )}
                              </div>
                              <a
                                href="/#"
                                onClick={e => {
                                  this.handleArchiveNotification(e, id)
                                }}
                                className="notifications_item_delete"
                              >
                                Delete
                              </a>
                            </li>
                          </CSSTransition>
                        )
                      })}
                  </TransitionGroup>
                  <li className="col-3 notifications_item align-self-end">
                    <a className="notifications_item_more-btn" href="/profile">
                      See more notifications
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    )
  }
}

Notifications.propTypes = {
  onFetchNotifications: propTypes.func.isRequired,
  onArchiveNotification: propTypes.func.isRequired,
  store: propTypes.shape({
    notifications: propTypes.arrayOf(
      propTypes.shape({
        id: propTypes.oneOfType([propTypes.string, propTypes.number]),
        description: propTypes.string,
        href: propTypes.string
      })
    ),
    notificationCount: propTypes.number,
    user: propTypes.shape({
      token: propTypes.string
    })
  }).isRequired
}

const mapStateToProps = ({ NotificationsReducer, AuthenticationReducer }) => ({
  store: {
    notifications: NotificationsReducer.unread,
    notificationCount: NotificationsReducer.unreadCounter,
    user: AuthenticationReducer.user
  }
})

const mapDispatchToProps = dispatch => ({
  onFetchNotifications: token => dispatch(fetchNotifications(token)),
  onArchiveNotification: (token, listId) =>
    dispatch(archiveNotification(token, listId))
})

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)
